(function () {
  var STORAGE_KEY = 'm-wishlist-products';

  function readList() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (Array.isArray(stored)) {
        return Array.from(new Set(stored.filter(Boolean)));
      }
    } catch (err) {
      console.warn('[MelanoWishlist] Corrupted storage reset', err);
    }
    return [];
  }

  function writeList(list) {
    var unique = Array.from(new Set((list || []).filter(Boolean)));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));

    // Keep Minimog native Wishlist object in sync if present
    if (window.MinimogTheme && window.MinimogTheme.Wishlist) {
      window.MinimogTheme.Wishlist.products = unique.slice();
    }

    updateCounts(unique);
    syncButtons(unique);

    // Dispatch global events for instant UI reactivity
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { products: unique, count: unique.length } }));
    window.dispatchEvent(new CustomEvent('melano:wishlist:updated', { detail: { products: unique, count: unique.length } }));

    return unique;
  }

  function getHandle(btn) {
    if (!btn) return '';
    return btn.getAttribute('data-product-handle') || btn.dataset.productHandle || '';
  }

  function updateCounts(list) {
    var currentList = Array.isArray(list) ? list : readList();
    var size = currentList.length;

    var countElems = document.querySelectorAll('.m-wishlist-count, .melano-hdr__action-wishlist .melano-hdr__cart-badge');
    countElems.forEach(function (el) {
      el.textContent = size;
      if (size < 1) {
        el.hidden = true;
        el.classList.add('m:hidden');
        el.style.display = 'none';
      } else {
        el.hidden = false;
        el.classList.remove('m:hidden');
        el.style.display = 'inline-flex';
      }
    });

    document.body.classList.toggle('wishlist-has-item', size > 0);

    if (window.MinimogTheme && window.MinimogTheme.Wishlist) {
      window.MinimogTheme.Wishlist.products = currentList.slice();
    }
  }

  function syncButtons(list) {
    var handles = Array.isArray(list) ? list : readList();
    document.querySelectorAll('.melano-btn-wishlist, .m-wishlist-button').forEach(function (btn) {
      var handle = getHandle(btn);
      if (!handle) return;
      var liked = handles.indexOf(handle) !== -1;
      btn.classList.toggle('is-liked', liked);
      btn.classList.toggle('added-to-wishlist', liked);
      btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
      btn.setAttribute('aria-label', liked ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function add(handle) {
    if (!handle) return;
    var list = readList();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      writeList(list);
    }
  }

  function remove(handle) {
    if (!handle) return;
    var list = readList();
    var updated = list.filter(function (h) { return h !== handle; });
    writeList(updated);
  }

  function toggle(btn) {
    var handle = getHandle(btn);
    if (!handle) return;

    var list = readList();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    list = writeList(list);

    btn.classList.remove('is-clicked');
    void btn.offsetWidth;
    btn.classList.add('is-clicked');
  }

  function init() {
    var list = readList();
    updateCounts(list);
    syncButtons(list);
  }

  // Global Event Delegation for Wishlist Buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.melano-btn-wishlist, .m-wishlist-button');
    if (!btn) return;
    // Don't intercept remove buttons on the wishlist page
    if (btn.hasAttribute('data-remove-handle') || btn.classList.contains('melano-wl-action-btn--remove')) return;

    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);

  // Multi-tab synchronization
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      init();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // Observer for dynamically injected product cards (infinite scroll, tabs, sliders)
  var scheduled = null;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = setTimeout(function () {
      scheduled = null;
      init();
    }, 150);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.MelanoWishlist = {
    get: readList,
    add: add,
    remove: remove,
    write: writeList,
    toggle: toggle,
    sync: init
  };
})();
